import React from 'react';
import '../../../styles/modes/compareMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Compare Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Compare algorithm-generated allocation solutions with manually created allocations to evaluate efficiency and identify optimization opportunities in Transportation Problem solving.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>At least one allocation created in Auto Path Mode</li>
            <li>At least one allocation created in Custom Path Mode</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Create Both Allocations:</strong>
              <ul>
                <li>Go to Auto Path Mode and solve to generate optimal allocation</li>
                <li>Go to Custom Path Mode and create your own allocation plan</li>
                <li>Both solutions will be stored automatically</li>
              </ul>
            </li>
            <li><strong>View Comparison:</strong>
              <ul>
                <li>Switch to Compare Mode</li>
                <li>Both allocation solutions are displayed side by side</li>
                <li>Routes shown on map with different colors</li>
              </ul>
            </li>
            <li><strong>Review Allocation Information:</strong>
              <ul>
                <li><strong>Auto Allocation:</strong> Algorithm-generated solution
                  <ul>
                    <li>Total cost</li>
                    <li>Allocation matrix</li>
                    <li>Shipment routes</li>
                  </ul>
                </li>
                <li><strong>Custom Allocation:</strong> Manual solution
                  <ul>
                    <li>Total cost</li>
                    <li>Allocation matrix</li>
                    <li>Shipment routes</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Analyze Comparison Results:</strong>
              <ul>
                <li><strong>Cost Difference:</strong> Shows savings or extra cost</li>
                <li><strong>Efficiency Analysis:</strong> Which allocation is more cost-effective</li>
                <li><strong>Detailed Breakdown:</strong> Click for segment-by-segment comparison</li>
              </ul>
            </li>
          </ol>

          <p><strong>Comparison Metrics:</strong></p>
          <ul>
            <li><strong>Total Distance:</strong> Sum of all shipment distances in kilometers</li>
            <li><strong>Flow Count:</strong> Number of supply-to-demand cargo flows</li>
            <li><strong>Distance Difference:</strong> Absolute difference in km and percentage</li>
            <li><strong>Efficiency Rating:</strong> Which solution uses shorter total distance</li>
          </ul>

          <p><strong>Interpretation:</strong></p>
          <ul>
            <li><strong>"Saved X km":</strong> Custom allocation is more efficient (shorter total distance)</li>
            <li><strong>"Extra X km":</strong> Auto allocation is more efficient (algorithm found shorter routes)</li>
            <li><strong>Percentage Difference:</strong> Shows relative efficiency gap between solutions</li>
          </ul>

          <p><strong>Display Information:</strong></p>
          <ul>
            <li><strong>Auto Path:</strong> Shows algorithm solution with cargo flows grouped by supply</li>
            <li><strong>Custom Path:</strong> Shows manual allocation with flows grouped by warehouse</li>
            <li><strong>Flow Details:</strong> Each flow shows destination, quantity, and distance</li>
            <li><strong>Visual Map:</strong> Both allocations displayed with different colors</li>
          </ul>

          <p><strong>Use Cases:</strong></p>
          <ul>
            <li>Validate algorithm solutions against practical constraints</li>
            <li>Learn optimal allocation patterns from algorithms</li>
            <li>Identify distance-saving opportunities in manual planning</li>
            <li>Evaluate trade-offs between different allocation strategies</li>
            <li>Understand impact of allocation decisions on total transportation distance</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Both allocations must be created before comparison is available</li>
            <li>Use detailed comparison to understand specific flow differences</li>
            <li>Lower total distance generally means lower transportation costs</li>
            <li>Algorithm solutions minimize distance but may not consider all real-world constraints</li>
            <li>Consider both distance efficiency and practical feasibility</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 